export default "__VITE_ASSET__DPsgYjXL__"